<template>
  <!-- Header Card -->
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <h3 class="text-lg font-semibold">{{ reception.note_ref }}</h3>
      <p class="mt-2 text-gray-600">
        <template v-if="reception.note_type == 'CSTMR'">
          <h5>
            Date de création :
            <b v-if="reception.created_at">
              {{ getDate(reception.created_at) }}</b
            >
            | Client : <b> {{ reception.note_customer_name }} </b>
          </h5>
        </template>
        <template v-if="reception.note_type == 'GLOBAL'">
          <span>
            Date de création :
            <b v-if="reception.created_at">
              {{ getDate(reception.created_at) }}</b
            >
            | <b> GLOBAL </b>
          </span>
        </template>
        <template v-if="reception.note_type == 'STOCK'">
          <span>
            Date de création :
            <b v-if="reception.created_at">
              {{ getDate(reception.created_at) }}</b
            >
            | <b> STOCK </b>
          </span>
        </template>
        <template v-if="reception.note_type == 'HC'">
          <span>
            Date de création :
            <b v-if="reception.created_at">
              {{ getDate(reception.created_at) }}</b
            >
          </span>
        </template>
      </p>
      <div class="d-flex flex-wrap align-items-center mt-15">
        <button
          v-if="Object.keys(reception).length != 0 && reception.note_saved != 1"
          class="btn btn-outline-success me-3 mb-3"
          @click="saveReception"
        >
          <i class="flaticon-save"></i> Enregister
        </button>

        <button
          v-else-if="
            Object.keys(reception).length != 0 && reception.note_saved == 1
          "
          class="btn btn-outline-success me-3 mb-3"
          @click="openReception"
        >
          <i class="flaticon-unlock"></i> Ouvrir
        </button>
      </div>
    </div>
  </div>

  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
    v-if="Object.keys(reception).length != 0 && reception.note_saved != 1"
  >
    <div class="card-header">
      <h6>Scan code suivi</h6>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form v-on:submit.prevent="searchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-9">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  placeholder="Code Suivi"
                  type="text"
                  id="scanFocus"
                  ref="scaninput"
                  v-model="codeColis"
                  class="form-control"
                />
              </div>
            </div>

            <div class="col-md-3">
              <button
                style="margin-right: 12px"
                class="btn btn-success me-3 mb-3 mt-3"
                type="submit"
              >
                <i class="ph ph-scan"></i>
              </button>
              <button
                class="btn btn-primary me-3 mb-3 mt-3"
                @click="refreshAll"
              >
                <i class="ph ph-arrows-clockwise"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Liste des nouveaux colis -->
  <!-- <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="border-b p-4">
      <h3 class="text-lg font-semibold">Liste des nouveaux colis</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('ADD_RECEPTION') && reception.note_stock_delivered == 0"
          @click="addNewColis"
        >
          Ajouter
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          v-model="searchTerm1"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :row-key="'id'"
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Demandes Sélectionées',
        }"
        @selected-rows-change="selectionChanged"
        @select-all="onSelectAll"
      >
        <template #emptystate>
          <div class="text-center py-4 text-gray">
            Aucune entrées correspondants trouvés
          </div>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>

          <template v-else-if="props.column.field === 'created_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.created_at) }}
            </span>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div> -->

  <!-- Liste des colis ajoutés -->
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="border-b p-4">
      <h3 class="text-lg font-semibold">Liste des colis ajoutés</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="
            auth.can('ADD_RECEPTION') &&
            Object.keys(reception).length != 0 &&
            reception.note_saved != 1
          "
          @click="removeNewColis"
        >
          Supprimer
          <i class="flaticon-delete position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          @change="getRows2()"
          @input="handleInput"
          v-model="searchTerm"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table
        :search-options="{ enabled: true, externalQuery: searchTerm2 }"
        :columns="columns"
        :row-key="'id'"
        :rows="rows2"
        responsive
        :select-options="{
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis sélectionées',
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <template #emptystate>
          <div class="text-center py-4 text-gray">
            Aucune entrées correspondants trouvés
          </div>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="icon-repeat"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="icon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>

          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users2"
        :offset="9"
        @paginate="getRows2"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useGlobalStore } from "@/stores/global";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
// import PaginatorContent from "@/components/PaginatorContent.vue";

export default defineComponent({
  name: "EditNote",

  components: {
    // CreateNewUserModal,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const route = useRoute();
    const auth = useAuthStore();
    const user = auth.user;

    // props / states
    const reception = ref<any>({});

    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const direction = ref("ltr");
    const codeColis = ref("");
    const searchTerm = ref("");

    // dummy columns and rows
    const columns = ref([
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Destinataire",
        field: "receiver",
      },
      {
        label: "Date de création",
        field: "updated_at",
      },
      {
        label: "Prix",
        field: "price",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Statut",
        field: "status",
      },
    ]);

    const selectedRows = ref([]);
    const selectedNewRows = ref([]);

    const rows1 = ref([]);
    const rows2 = ref([]);

    const globalStore = useGlobalStore();

    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // methods
    const getDate = (date) =>
      new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    async function addNewColis() {
      console.log(selectedRows);
      try {
        if (!selectedRows.value.length) {
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("UserID", String(user?.id));
        data.append("colis", JSON.stringify(selectedRows.value));
        data.append(
          "refReception",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );

        const res = await api.post(`/api/auth/ColisToBrc`, data);

        if (res.data.message === "success") {
          // Play audio
          const audio = new Audio("/sound.mp3");
          audio.play();

          showToast("Ajoutées avec succès", "success");
          getData(); // refresh data
        } else {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Erreur lors de l’ajout", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    async function removeNewColis() {
      try {
        if (!selectedNewRows.value.length) {
          // show toast if no selection
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("UserID", user?.id);
        data.append("colis", JSON.stringify(selectedNewRows.value));
        data.append(
          "refReception",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );

        const res = await api.post(`/api/auth/ColisFromBrc`, data);

        if (res.data.message === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();

          showToast("Supprimées avec succès", "success");
          getData(); // refresh table data
        } else {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Une erreur est survenue, veuillez réessayer", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    function selectionChanged(params) {
      selectedRows.value = params.selectedRows;
    }

    function onSelectAll(params) {
      selectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params) {
      console.log(params);

      selectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params) {
      console.log(params);
      selectedNewRows.value = params.selectedRows;
    }

    const getData = async () => {
      try {
        const res = await api.get(
          `/api/auth/GetNoteRecp?cstmr_id=${0}&ref=${route.params.refNote}`
        );
        reception.value = res.data; // update reactive ref
      } catch (err) {
        console.error("Erreur lors du chargement du bon:", err);
      }
      // getRows1();
      getRows2();
    };
    async function getRows1() {
      try {
        const res = await api.get(`/api/auth/ColiGlobalNote`);
        // Object.assign(reception, res.data);
        rows1.value = res.data.users.data;
        // Object.assign(users1, res.data.users);
      } catch (err) {
        console.error(err);
      }
    }

    async function getRows2() {
      try {
        const res = await api.get(`/api/auth/ColisInGlobalNote`, {
          params: {
            ref: route.params.refNote,
          },
        });
        // Object.assign(reception, res.data);
        rows2.value = res.data.users.data;
        Object.assign(users2, res.data.users);
      } catch (err) {
        console.error(err);
      }
    }

    onMounted(async () => {
      getData();
    });

    async function saveReception() {
      try {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append(
          "ref_note",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );
        data.append(
          "cstmr",
          Array.isArray(route.params.id)
            ? route.params.id[0]
            : String(route.params.id)
        );

        const res = await api.post(`/api/auth/SaveBrc`, data);

        if (res.data.message === "success") {
          getData();
          showToast("Bon de réception est bien enregistré", "success");
        } else if (res.data.message === "no edit") {
          showToast("Aucune modification à faire", "error");
        } else {
          showToast("Something went wrong! Please try again", "error");
        }
      } catch (error) {
        console.error("Error saving reception:", error);
        showToast(
          "Erreur lors de l’enregistrement du bon de réception",
          "error"
        );
      }
    }

    async function openReception() {
      try {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append(
          "ref_note",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );
        data.append(
          "cstmr",
          Array.isArray(route.params.id)
            ? route.params.id[0]
            : String(route.params.id)
        );

        const res = await api.post(`/api/auth/OpenBrc`, data);

        if (res.data.message === "success") {
          getData();
          showToast("Bon de réception est bien ouvert", "success");
        } else if (res.data.message === "no edit") {
          showToast("Aucune modification à faire", "error");
        } else {
          showToast("Something went wrong! Please try again", "error");
        }
      } catch (error) {
        console.error("Error opening reception:", error);
        showToast("Erreur lors de l’ouverture du bon de réception", "error");
      }
    }

    async function searchColis() {
      try {
        // isLoader.value = true;

        let data = new FormData();
        data.append("code_colis", codeColis.value);
        data.append(
          "refReception",
          Array.isArray(route.params.refNote)
            ? route.params.refNote[0]
            : String(route.params.refNote)
        );

        const res = await api.post(`/api/auth/SearchColisNote`, data);

        // Reset input
        codeColis.value = "";
        document.getElementById("scanFocus").focus();

        const playSound = (file) => {
          // var audio = new Audio(require(`@/assets/${file}`));
          // audio.play();
          console.log("Playing sound:", file);
        };

        if (res.data.message === "success") {
          getRows2();
          const audio = new Audio("/sound.mp3");
          audio.play();
          showToast("Colis est bien ajouté", "success");
        } else if (res.data.message === "not exist") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Colis n'existe pas", "error");
        } else if (res.data.message === "note invalid") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Vous ne pouvez pas ajouter à ce bon", "error");
        } else if (res.data.message === "exist in note") {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Colis existe déjà dans un bon", "error");
        }
      } catch (error) {
        console.error("Error searching colis:", error);
        showToast("Erreur lors de la recherche du colis", "error");
      } finally {
        // isLoader.value = false;
      }
    }

    function refreshAll() {
      getData();
      document.getElementById("scanFocus").focus();
    }

    // Declare debounceTimer variable
    let debounceTimer: ReturnType<typeof setTimeout> | undefined;

    function handleInput() {
      // Clear previous debounce timer
      clearTimeout(debounceTimer);

      // Set a new debounce timer
      debounceTimer = setTimeout(() => {
        if (!searchTerm.value || searchTerm.value === "") {
          users2.searchTerm = searchTerm.value;
          getRows2();
        } else if (searchTerm.value && searchTerm.value.length > 4) {
          users2.searchTerm = searchTerm.value;
          getRows2();
        }
      }, 500); // Adjust the delay (in milliseconds) as needed
    }

    return {
      auth,
      reception,
      columns,
      rows2,
      rows1,
      users2,
      getDate,
      addNewColis,
      removeNewColis,
      onSelectAll,
      selectionChanged,
      selectionChangedColis,
      onSelectAllColis,
      searchTerm1,
      searchTerm2,
      direction,
      selectedNewRows,
      selectedRows,
      searchTerm,

      getRows2,
      getRows1,

      openReception,
      saveReception,
      refreshAll,
      searchColis,
      codeColis,
      handleInput,
      globalStore,
    };
  },
});
</script>